import clsx from 'clsx';
import React, { forwardRef } from 'react';

import * as styles from './Table.css';
import { VirtuosoTableProps } from './VirtuosoTableContext';

export const VirtuosoTableFooter = forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement> & VirtuosoTableProps<any>
>(function VirtuosoTableFooter({ children, context, className, ...rest }, ref) {
  return (
    <tfoot ref={ref} className={clsx(styles.tableFooter, className)} {...rest}>
      {children}
    </tfoot>
  );
});
